import { createApiDescription } from "../../helperFunctions";

export const draftReportInfo = {
    deleteDraftSignature: createApiDescription(
        "This API can be called to delete the draft signatures.",
        [
            "API is used to delete signatures if present in draft signature report page.",
            "API supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header. Once request is sent from Draft Signature API, the response will be posted to the configured callback endpoint URL."
        ]
    ),
    getDraftSignature: createApiDescription(
        "Draft Signatures API provides results based on the given filters.",
        [
            "Draft Signatures API provide results based on the given filters on the request parameters and if no filter values are given, it provides results based on default value mapped with all filters.",
            "The default number of signature documents in the response will be 10.",
            "It will display the records with current tax year applied as a default filter like signature application."
        ]
    )
}